// extracted by mini-css-extract-plugin
export default {"optionCard":"HowToInviteNeighborsModal_optionCard__-eg-5","superTitle":"HowToInviteNeighborsModal_superTitle__uo9Gw","tipBanner":"HowToInviteNeighborsModal_tipBanner__-e6J3"};